import React from "react"
import { titleCase } from "../utilFunctions";

const Colors = (props) => {
  const {status} = props
  return (
    <div>
         {titleCase(status) == "Rejected" ? <span className="text-danger">{titleCase(status)}</span> 
         : (titleCase(status) == "Open" || titleCase(status) == "Completed")  ? <span className="text-success">{titleCase(status)}</span> 
         :  titleCase(status) == "Closed"  ? <span className="text-secondary">{titleCase(status)}</span> 
         :  (titleCase(status) == "Registered" || titleCase(status) == "Submitted") ? <span className="text-primary">{titleCase(status)}</span> 
         : (titleCase(status) == "Intimation") ? <span className="text-secondary">{titleCase(status)}</span> 
         : <span className="text-secondary">{titleCase(status)}</span>}
    </div>
  )
};

export default Colors;